import { render, staticRenderFns } from "./AttachmentGrid.vue?vue&type=template&id=97ca6e54"
import script from "./AttachmentGrid.vue?vue&type=script&lang=js"
export * from "./AttachmentGrid.vue?vue&type=script&lang=js"
import style0 from "./AttachmentGrid.vue?vue&type=style&index=0&id=97ca6e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports